import { useState, useRef, useEffect } from 'react';

export const useImageContainer = (url: string) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const img = document.createElement('img');
    img.src = url;
    img.onload = () => setImage(img);
    img.onerror = () => console.error('Failed to load image.');
  }, [url]);

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setContainerSize({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight,
        });
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return { image, containerRef, containerSize };
}; 